import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-workflow_data-sync",
  "use": "icon-workflow_data-sync-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-workflow_data-sync\">\n  <g stroke-width=\"2\" stroke-linecap=\"round\">\n    <path stroke=\"currentColor\" fill=\"transparent\" d=\"M27 17.779H15M17.88 15l-2.877 2.779M15 22.5h12M24.12 25.279l2.877-2.78M12.186 27H6.444C5.094 27 4 26.023 4 24.818V10.333 5.182C4 3.977 5.094 3 6.444 3H23.556C24.906 3 26 3.977 26 5.182v5.842\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol